import { render, staticRenderFns } from "./sjz.vue?vue&type=template&id=56251322&scoped=true"
import script from "./sjz.vue?vue&type=script&lang=js"
export * from "./sjz.vue?vue&type=script&lang=js"
import style0 from "./sjz.vue?vue&type=style&index=0&id=56251322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56251322",
  null
  
)

export default component.exports